export const OPTIMISTIC_SHARE_ID = 'optimistic-share-id'
